module.exports = "uniform sampler2D tDiffuse;\r\n\r\nvarying vec2 f_uv;\r\n\r\nvoid main() {\r\n    gl_FragColor = texture2D(tDiffuse, f_uv);\r\n}   "


//////////////////
// WEBPACK FOOTER
// ./src/shaders/post/compose_replace.frag.glsl
// module id = 47
// module chunks = 0